<template>
    <section class="userSteps">
        <Header />
        <!-- <div class="d-flex justify-content-end padSpace" @click="store.clearMessage">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div> -->
        <div class="publicProfile row">
            <div class="messageBlock my-1" v-if="store.error.msg">
                <p class="alert" :class="(store.error.type == 'error') ? 'alert-danger' : 'alert-success'">{{store.error.msg}}</p>
            </div>
            <div class="messageBlock my-1" v-if="store.user.access_token && (store.customerDetail.phoneNumber == '' || !store.customerDetail.phoneNumber || !store.customerDetail.countryIsoCodeA3  || store.customerDetail.countryIsoCodeA3 =='')">
                <p class="alert alert-danger">
                   In order to complete registration, please update 
                    <span v-if="!store.customerDetail.phoneNumber || store.customerDetail.phoneNumber == ''"> phone number</span>
                    <span v-if="store.customerDetail.countryIsoCodeA3 && store.customerDetail.countryIsoCodeA3 != ''">.</span>
                    <span v-if="(!store.customerDetail.phoneNumber|| store.customerDetail.phoneNumber == '' )&& (!store.customerDetail.countryIsoCodeA3 || store.customerDetail.countryIsoCodeA3 == '') "> and </span>
                    <span v-if="!store.customerDetail.countryIsoCodeA3 || store.customerDetail.countryIsoCodeA3 == ''">country.</span>
                </p>
            </div>
            <div class="col-12 mt-3">
                <div class="counterStep text-end">
                    <p>{{$t('personal_details.text1')}}</p>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <Form class="personalDetails" @submit="submit">
                    <div class="mainTitle mb-4">
                        <h3 class="mb-3 clash">{{$t('personal_details.text2')}}<span class="bgTitle">{{$t('personal_details.text3')}}</span></h3>
                        <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet justo dui. Proin
                            et gravida lacus.</p> -->
                    </div>
                    <h4 class="mb-4">{{$t('personal_details.text4')}}</h4>
                    <float-label class="form-group">
                        <Field
                          class="form-control"
                          name="first name"
                          @keydown = "onInputString($event,'fname')"
                          :placeholder="$t('personal_details.text5')"
                          v-model="form.fname"
                          rules="required"
                        />
                        
                        <ErrorMessage class="text-danger" name="first name" />
                    </float-label>
                    <float-label class="form-group">
                        <Field
                          class="form-control"
                          name="last name"
                          @keydown = "onInputString($event,'lname')"
                          :placeholder="$t('personal_details.text6')"
                          v-model="form.lname"
                          rules="required"
                        />
                        <ErrorMessage class="text-danger" name="last name" />
                    </float-label>
                    <div class="countrySelect form-group position-relative filter-dropdown"  :class="[{'selected' : country.name}]">
                        <a @click="selectButton = !selectButton" href="javascript:void(0)"
                            class="selectButton d-flex align-items-center justify-content-between"><span
                                class="d-flex align-items-center" v-if="country.id && country.name"><img class="me-2" :src="'/assets/images/country_flag/'+country.name.toLowerCase()+'.webp'"
                                    :alt="$t('personal_details.text21')" :title="$t('personal_details.text21')" loading="lazy" width="20" height="20"/>{{country.name}}</span>
                                    <span v-else>&nbsp;</span>
                            <vue-feather size="20" type="chevron-down"></vue-feather>
                        </a>
                        <label class="afterSelect">{{$t('personal_details.text7')}}</label>
                        <ul class="dropdown_menu_animated scrollable" :class="selectButton ? 'show' : ''" > 
                            <li class="form-group mb-1">
                                <input type="text" :placeholder="$t('personal_details.text8')" class="form-control radius-0" v-model="countrysearch" />
                            </li>
                            <li v-for="item,key in getCountries" :key="key">
                                <a href="javascript:void(0)" class="d-flex align-items-center" @click="country = item;selectButton = false;countrysearch = '';changecountry(item)" ><img class="me-2"
                                        :src="'/assets/images/country_flag/'+item.name.toLowerCase()+'.webp'" :alt="$t('personal_details.text21')" :title="item.name" loading="lazy" width="20" height="20"/>
                                    {{item.name}}</a>
                            </li>
                        </ul>
                        <span v-if="isCountry" role="alert" class="text-danger">{{$t('changes.text6')}}</span>
                    </div>
                    <float-label class="form-group">
                         <Field
                          class="form-control"
                          name="email"
                          :placeholder="$t('personal_details.text9')"
                          v-model="form.email"
                          rules="required"
                          :disabled="(store.customerDetail.email && store.customerDetail.emailVerified) ? true : false"
                        />
                        <ErrorMessage class="text-danger" name="email" />
                            <div class="loaderButton spinner-border primary" role="status" v-if="store.singleLoading && !showEmailCode">
                                <span class="visually-hidden">{{$t('personal_details.text10')}}</span>
                            </div>
                            <a href="javascript:void(0)" class="getCode semibold" v-if="!store.singleLoading && validMail && !store.customerDetail.emailVerified" @click="SubmitData('Email')">{{ !showEmailCode ? 'Get Code' : 'Resend Code'}}</a>
                        <span class="verifyed semibold" v-if="store.customerDetail.emailVerified && store.customerDetail.email">{{$t('personal_details.text11')}}</span>
                    </float-label>
                    <float-label class="form-group pdataEmail" v-if="showEmailCode">
                        <v-otp-input
                            separator=""
                            input-classes="otp-input"
                            :num-inputs="6"
                            :shouldAutoFocus="true"
                            @on-change="handleOnChange"
                            @on-complete="handleOnComplete"
                            :autoFormat="false"
                          />
                          <Field
                              style="display: none;"
                              class="form-control"
                              name="otp"
                              placeholder=""
                              v-model="form.emailcode"
                              rules="required|min:6"
                            />
                        <ErrorMessage class="text-danger" name="otp" />
                        <a href="javascript:void(0)"  class="getCode semibold" @click="verifyEmailOTP()">
                            <div class="loaderButton spinner-border primary" role="status" v-if="store.singleLoading && showEmailCode">
                                <span class="visually-hidden">{{$t('personal_details.text10')}}</span>
                            </div>
                            <span v-else>{{$t('personal_details.text12')}}</span>
                        </a>
                    </float-label>
                    <div class="form-group mb-4 position-relative" :class="selectNumber ? 'selected' : ''">
                        <!-- :rules="'required|digits:'+selected_country_phone_limit"  -->
                        <Field
                            v-slot="{ field }"
                            name="Phone Number"
                            :rules="'required|min:7|max:15'" 
                            v-model="form.mobile" >
                            <vue-tel-input
                            v-bind="field"
                            :auto-format = "false"
                            v-model="form.mobile"
                            @blur="onMobileInput"
                            @keyup="onMobileInput"
                            :custom-validate="form.mobile!=''? new RegExp(/^[0-9]+$/):false"
                            @country-changed="GetCode"
                            :inputOptions="options"
                            :validCharactersOnly = "true"
                            ref="phone"
                            :disabled="(store.customerDetail.phoneNumber && store.customerDetail.phoneVerified) ? true : false "
                            :onlyCountries ="getAllowCountry()"
                            ></vue-tel-input>
                      </Field>
                      <ErrorMessage class="text-danger" name="Phone Number" />


                       <span class="verifyed semibold" v-if="store.customerDetail.phoneVerified && store.customerDetail.phoneNumber">VERIFIED</span>
                         <a href="javascript:void(0)" class="getCode semibold" v-if="validPhone && !store.customerDetail.phoneVerified" @click="SubmitData('Phone')">
                            <div class="loaderButton spinner-border primary" role="status" v-if="store.loader && !showSMSCode">
                                <span class="visually-hidden">{{$t('personal_details.text10')}}</span>
                            </div>
                            <span v-else>{{(!showSMSCode ? 'Get Code' : (showOtp) ? `${countTime}s`  : 'Resend Code')}}</span>
                         </a>
                         <!-- <span v-if="isPhone" role="alert" class="text-danger">{{$t('changes.text8')}}</span> -->
                         
                       <div class="d-flex justify-content-end" v-if="PhoneInstruction">
                        <div class="tooltipbutton">
                                <span class="tooltiptext f-12">
                                    <ul class="dotList">
                                        <li>{{$t('personal_details.text13')}}</li>
                                        <li>{{$t('personal_details.text14')}}</li>
                                        <li>{{$t('personal_details.text15')}}</li>
                                        <li>{{$t('personal_details.text16')}}</li>
                                    </ul>
                                </span>
                                <p class="alertNumber d-flex align-items-center mb-0 f-12">{{$t('personal_details.text17')}}<vue-feather size="15" class="flex-shrink-0 smallSize ms-1" type="alert-circle"></vue-feather> </p>
                            </div>
                        </div>
                    </div>
                    <float-label class="form-group" v-if="showSMSCode">
                        <Field
                         type="number"
                          class="form-control"
                          name="mobile otp"
                          :placeholder="$t('personal_details.text18')"
                          v-model="form.smscode"
                          rules="required"
                        />
                        <ErrorMessage class="text-danger" name="mobile otp" />
                        <a href="javascript:void(0)" class="getCode semibold" @click="verifySMSOTP()">
                            <div class="loaderButton spinner-border primary" role="status" v-if="store.loader && showSMSCode">
                                <span class="visually-hidden">{{$t('personal_details.text10')}}</span>
                            </div>
                            <span v-else>{{$t('personal_details.text12')}}</span>
                        </a>
                    </float-label>
                    <!-- <float-label class="form-group">
                        <Field
                          class="form-control"
                          name="Display name"
                          placeholder="Display Name"
                          v-model="form.username"
                          rules="required"
                        />
                        <ErrorMessage class="text-danger" name="Display name" />
                    </float-label> -->
                    
                    <label class="customCheckBox line-4 mb-4">
                        {{$t('get_otp.text5')}}<a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}terms-of-service`">{{$t('get_otp.text6')}}</a>,
                        <a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}privacy-policy`">{{$t('get_otp.text7')}}</a>,
                        <a class="semibold underline" :href="`${static_vars.domainURL}conflict-of-interest-policy`" target="_blank">{{$t('get_otp.text8')}}</a>,
                        <a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}declaration-of-consent`">{{$t('get_otp.text9')}}</a>{{$t('get_otp.text10')}}
                        <a target="_blank" class="semibold underline" :href="`${static_vars.domainURL}risk-disclaimer`">{{$t('get_otp.text11')}}</a>
                        <input type="checkbox" v-model="form.terms" />
                        <Field type="hidden" name="Terms" rules="required" v-if="!form.terms" />
                        <span class="checkmark"></span>
                    </label>
                    <ErrorMessage name="Terms" class="text-danger" />
                    <div class="buttonElement mb-3">
                        <button type="submit" class="grd_btn full_size" :class="[{'disabled' : !captchaToken || !country.id || !store.customerDetail.emailVerified }]"> {{$t('personal_details.text19')}}</button>
                    </div>
                </Form>
            </div>
            <div class="col-12 col-md-6">
                <div class="accordion accordion-flush ps-md-5" id="accordionFlushExample">
                    <h4 class="semibold">{{$t('personal_details.text20')}}</h4>
                    <div class="accordion-item" v-for="value,key,index in static_vars.brokerFAQ" :key="index">
                        <h2 class="accordion-header" :class="(showfaq == index) ? 'show' : ''">
                            <button class="accordion-button" type="button" @click="(showfaq != index) ? showfaq = index : -1">
                                {{key}}
                            </button>
                        </h2>
                        <div  class="accordion-collapse collapse" :class="(showfaq == index) ? 'show' : ''"
                        >
                            <div class="accordion-body graycontent">{{value}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import { useMainStore } from "@/store";
import FloatLabel from 'vue-float-label/components/FloatLabel'
import { Form, Field, ErrorMessage } from "vee-validate";
import $ from 'jquery'
import { load } from 'recaptcha-v3'
import jsonData from '../../../public/countries.json';
import { useToast } from 'vue-toastification'
const toast = useToast();
export default {
    setup() {
        const store = useMainStore();
        const Crypto = require("crypto-js")
        return { store,Crypto };//Crypto
      },
    data() {
        return {
            selectButton: false,
            selectNumber: false,
            showDemoAccountProcessing:false,
            form : {
                fname : '',
                lname : '',
                email : '',
                emailcode : '',
                mobile : '',
                phonecode : '',
                smscode : '',
                username : '',
                file : {},
                name : '',
                terms:false
            },
            captchaToken : '',
            showfaq : 0,
            countryname : '',
            countrysearch : '',
            showEmailCode : false,
            country : {},
            showSMSCode : false,
            uploadedImage : '',
            validMail : false,
            validPhone : false,
            type : '',
            PhoneInstruction : false,
            countTime : 60,
            showOtp : false,
            options: { placeholder: "Enter your phone number" },
            isCountry: false,
            isPhone : false,
            selected_phone_country:null,
            countries_json:jsonData,
            default_mobile_length:10
        }
    },
    components: {
        FloatLabel,
        Form,
        Field,
        ErrorMessage,
    },
    watch :{
        'form.email'(){
            if(this.validEmail()){
                this.validMail = true
            }else{
                this.validMail = false
            }
        },
        'form.mobile'(val){
           if(val.length >= 7){
            this.validPhone = true
           }else{
            this.validPhone = false
           }

        },
        'store.customerDetail'(){
            if(Object.keys(this.store.customerDetail).length){
                this.form.email = (this.store.customerDetail.email) ? this.store.customerDetail.email : ''
                this.form.fname = (this.store.customerDetail.firstName) ? this.store.customerDetail.firstName : ''
                this.form.lname = (this.store.customerDetail.lastName) ? this.store.customerDetail.lastName : ''
            }
        },
        // 'form.fname'(){
        //     let pattern = /^\p{Script=Cyrillic}+$/u;
        //     if (pattern.test(this.form.fname)){
        //         this.form.fname = ""
        //         console.log('yessss')
        //     }
        // }
    },
    computed : {
        getCountries(){
            if(Object.keys(this.store.countryList).length > 0){
                let data = Object.values(this.store.countryList);
                if(this.countrysearch){
                    return data.filter(item => item.name.toLowerCase().includes(this.countrysearch.toLowerCase()))
                }else{
                    return data
                }

            }else{
                return []
            }
        },
        selected_country_phone_limit(){
            let selected_con = this.countries_json.find(arr=> arr.isoCode == this.selected_phone_country?.iso2);
            return selected_con ? selected_con.digits:this.default_mobile_length;
        }
    },
    methods:{
        getAllowCountry(){
          return Object.values(this.store.countryList).map((val) => val.isoCode) || [];
        },
        getCount(){
            if(this.countTime > 0){
                var interval = setInterval(()=>{
                    if(this.countTime > 0){
                        this.countTime = this.countTime-1
                    }else{
                        clearInterval(interval);
                        this.showOtp = false
                        this.showSMSCode = true
                         this.countTime = 60
                    }
                },1000)
            }

        },
        CretioFunc(){
            try{
              window.gtag('event', 'test_verify');
              window.fbq('trackCustom', 'email_verify', {'email' : this.store.userAccoutDetail?.email,'value' : '20','country' : this.store.flavorData?.userCountry?.name },{'eventID': `${this.store.userAccoutDetail?.id}_email_verify`});
              if(Object.keys(this.store.flavorData).length && this.store.flavorData.userCountry && Object.keys(this.store.flavorData.userCountry).length && this.store.flavorData.userCountry.isoCode){
                  for(var key in this.static_vars.cretioCountryJson){
                      if(key == this.store.flavorData.userCountry.isoCode){
                        var s = document.createElement("script");
                        s.type = "text/javascript";
                        s.async = true;
                        s.src = `//dynamic.criteo.com/js/ld/ld.js?a=${this.static_vars.cretioCountryJson[key]}`;
                        $("head").append(s);
                        window.criteo_q = window.criteo_q || [];
                        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
                          window .criteo_q.push(
                          { event: "setaccount", account: this.static_vars.cretioCountryJson[key]}, // You should never update this line
                          { event: "setSiteType", type: deviceType},
                         //{ event: "setemail", email: this.Crypto.SHA256(this.store.customerDetail.email).toString() , hash_method: "sha256" }, 
                         { event: "setemail", email: this.Crypto.SHA256('1').toString() , hash_method: "sha256" },
                            { event: "trackTransaction", id: (Math.random() * 50000), item: [
                                {id : Math.ceil(Math.random()*10300 * Math.random() * 50000), price:1, quality : 1}
                            ]}
                          );
                      }
                  }
              }
            }catch(e){
              console.log('cretio ex',e)
            }
        },
        validEmail(){
            let regexp =  /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return regexp.test(this.form.email.toLowerCase())
        },
        getTime(){
            var date = new Date();
            return date.getTime()
        },
        clearDoc(){
            document.getElementById("fileUpload").value = ''
            this.form.file = {}
            this.form.name = ''
        },
        uploadDoc(){
            document.getElementById("fileUpload").click()
        },
        submit(){
            let _that = this;
            load(`${this.static_vars.recaptchaKey}`, { useRecaptchaNet: true }).then((recaptcha) => {
                recaptcha.execute("login").then((token) => {
                    // console.log(token) // Will print the token
                    this.captchaToken = token;
                    if(this.captchaToken){
                        let formData = {};
                        formData['countryId'] = this.country.id
                        formData['countryIsoCodeA3'] = this.country.isoCode
                        formData['customerId'] = this.store.customerDetail.customerId
                        formData['firstName'] = this.form.fname
                        formData['lastName'] =  this.form.lname
                        // formData['profileName'] = this.form.username
                        if(!this.store.customerDetail.emailVerified && (this.store.customerDetail.email != this.form.email)){
                            formData['email'] = this.form.email
                        }
                        if((this.store.customerDetail.phoneNumber != this.form.mobile) && !this.store.customerDetail.phoneVerified){
                            formData['phoneCountryCode'] = this.form.phonecode
                            formData['phoneNumber'] = this.form.mobile
                        }
                        if(this.captchaToken){
                            formData['captcha'] = {};
                            formData['captcha']['response'] = this.captchaToken
                        }
                        if(!Object.keys(this.country).length){
                            this.isCountry = true
                        } else {
                            this.isCountry = false
                            if(!this.form.mobile){
                              this.isPhone = true
                            }else{
                                this.isPhone = false
                                this.store.callUpdateProfileInfo(formData,true,this).then( () =>{
                                    let demo_account = false;
                                    if(this.store?.userTradingAccountsList?.length){
                                        Object.keys(this.store.userTradingAccountsList).forEach(function(acc){
                                            if(_that.store.userTradingAccountsList[acc].demo == true){
                                                demo_account = true;
                                            } 
                                        });
                                    }
                                    if(demo_account == false){
                                        _that.$router.replace('/demo-acc');
                                        // _that.store.createDemoAccount()
                                        // .then(function(){
                                        //     _that.refreshToken();
                                        // })
                                        // .then(function(){
                                        //     _that.showDemoAccountProcessing = false;
                                        //     // _that.$router.replace('/upload-image')
                                        //     this.$router.replace('/complete-registration')
                                        // });
                                    }
                                    else{
                                        // _that.$router.replace('/upload-image')
                                        this.$router.replace('/complete-registration')
                                    }
                                })
                            }
                        }
                    }
                });
            });
            // if(this.form.file.name){
            //     this.uploadImage()
            // }
        },

        refreshToken:function(){
        let form = {
                'grant_type' : 'refresh_token',
                'refresh_token' : this.store.user.refresh_token
            };
            this.store.refreshToken(form,false,'basic').then((response) =>{
                if(response.access_token){
                    this.store.getUserAccountsList({},false)
                }
            })
        },
        SubmitData(type){
            load(`${this.static_vars.recaptchaKey}`, { useRecaptchaNet: true }).then((recaptcha) => {
                recaptcha.execute("login").then((token) => {
                    // console.log(token) // Will print the token
                    this.captchaToken = token;
                    this.type = type
                    let formData = {};
                    if(type == 'Email' && !this.store.customerDetail.emailVerified && (this.store.customerDetail.email != this.form.email)){
                        formData['email'] = this.form.email
                    }else if(type == 'Phone' && ((this.store.customerDetail.phoneNumber != this.form.mobile) && !this.store.customerDetail.phoneVerified)){
                        formData['phoneCountryCode'] = this.form.phonecode
                        formData['phoneNumber'] = this.form.mobile
                        if(this.form.email && !this.store.customerDetail.emailVerified && (this.store.customerDetail.email != this.form.email)){
                            formData['email'] = this.form.email
                        }
                    }
                    if(this.country.id){
                        formData['countryId'] = this.country.id
                    }
                    if(this.country.isoCode){
                        formData['countryIsoCodeA3'] = this.country.isoCode
                    }
                    if(this.store.customerDetail.customerId){
                        formData['customerId'] = this.store.customerDetail.customerId
                    }
                    if(this.form.fname){
                        formData['firstName'] = this.form.fname
                    }
                    if(this.form.lname){
                        formData['lastName'] =  this.form.lname
                    }
                    // if(this.form.username){
                    //     formData['profileName'] = this.form.username
                    // }
                    if(this.captchaToken){
                        formData['captcha'] = {};
                        formData['captcha']['response'] = this.captchaToken
                    }
                    this.store.callUpdateProfileInfo(formData,true,this,'Code').then(() =>{
                        // if(this.form.file.name){
                        //     this.uploadImage()
                        // }
                        //this.getUserDetail()
                        // this.validMail = false
                        // this.validPhone = false
                    })
                });
            });
        },
         addfileImage(file){
            return URL.createObjectURL(file);
        },
        setImage(event){
            this.form.file = event.target.files[0]
            this.form.name = this.form.file.name
        },
        handleOnComplete(value) {
        this.form.emailcode = value
        },
        handleOnChange(value) {
        this.form.emailcode = value
        },
        changecountry(item) {
          this.$refs.phone.choose(item.isoCode);
        },

        onInputString(e,field_name) {
            const keyCode = e.keyCode || e.which;
            if(!this.COMMON.validateIsString(keyCode)){
                e.preventDefault();
            }
            else{
                this.form[field_name] = e.target.value;      
            }
        },
        // onInput(e) {
        //     const keyCode = e.keyCode || e.which;
        //     if(!this.COMMON.validateIsNumber(keyCode) || (e.mobile == 0 && (keyCode == 96 || keyCode == 48))){
        //         e.preventDefault();
        //     }
        //     else{
        //         this.form.mobile = e.target.value;      
        //     }
        // },
        onMobileInput(){
            if(parseInt(this.form.mobile) == 0){
                this.form.mobile = '';
            }
        },
        GetCode(e) {
            this.selected_phone_country = e;
          this.form.phonecode = e.dialCode;
        },
        getEmailCode(){
            load(`${this.static_vars.recaptchaKey}`, { useRecaptchaNet: true }).then((recaptcha) => {
                recaptcha.execute("login").then((token) => {
                    // console.log(token) // Will print the token
                    this.captchaToken = token;
                    if(this.captchaToken){
                        let formData = {};
                        formData['identifier'] = 'EMAIL'
                        formData['email'] = this.store.customerDetail.email
                        if(this.captchaToken){
                          formData['captcha'] = {};
                          formData['captcha']['response'] = this.captchaToken
                        }
                        this.store.resendOTP(formData,true).then(() =>{
                            this.showEmailCode = true
                            this.type = ''
                        })
                    }
                });
            });
            
        },
        verifyEmailOTP(){
            let _that= this;
            load(`${this.static_vars.recaptchaKey}`, { useRecaptchaNet: true }).then((recaptcha) => {
                recaptcha.execute("login").then((token) => {
                    // console.log(token) // Will print the token
                    this.captchaToken = token;
                    if(this.form.emailcode && this.captchaToken){
                      let formData = {};
                      formData["code"] = this.form.emailcode
                      formData['email'] = this.store.customerDetail.email
                      formData["page"] = 'PersonalDetail'
                      if(this.captchaToken){
                          formData['captcha'] = {};
                          formData['captcha']['response'] = this.captchaToken
                      } 
                      this.store.verifyOTP(formData,true,this).then((response) =>{
                        if(response === true){
                            this.showEmailCode = false
                            let data = this.store.customerDetail
                            data.emailVerified = true
                            this.store.$patch({customerDetail : data});
                        }
                        else{
                            toast.error(_that.$t('view_login.text12'));
                        }
                      })
                    }
                });
            });
        },
        verifySMSOTP(){
            let _that = this;
            load(`${this.static_vars.recaptchaKey}`, { useRecaptchaNet: true }).then((recaptcha) => {
                recaptcha.execute("login").then((token) => {
                    // console.log(token) // Will print the token
                    this.captchaToken = token;
                    if(this.form.smscode && this.captchaToken){
                     let formData = {};
                      formData["code"] = this.form.smscode
                      //formData['email'] = this.store.customerDetail.email
                      if(this.captchaToken){
                        formData['captcha'] = {};
                        formData['captcha']['response'] = this.captchaToken
                    }
                      this.store.verifyMobileOTP(formData,true,this).then((response) =>{
                        if(response === true){
                            this.showSMSCode = false;
                            this.showOtp = false;
                            this.validPhone = false;
                             this.PhoneInstruction = false;
                            this.type = ''
                            this.form.smscode = ''
                            let data = this.store.customerDetail
                            data.phoneVerified = true
                            this.store.$patch({customerDetail : data});
                        }
                        else{
                            toast.error(_that.$t('view_login.text12'));
                        }
                      })
                    }
                });
            });
        },
        SendSMS(){
            load(`${this.static_vars.recaptchaKey}`, { useRecaptchaNet: true }).then((recaptcha) => {
                recaptcha.execute("login").then((token) => {
                    // console.log(token) // Will print the token
                    this.captchaToken = token;
                    if(this.captchaToken){
                        let formData = {};
                        if(this.captchaToken){
                            formData['captcha'] = {};
                            formData['captcha']['response'] = this.captchaToken
                        }
                        this.store.sendOtpMobile(formData,true).then((response) =>{
                            if(response === 6966){
                                this.PhoneInstruction = true
                            }else if (response === true) {
                                this.showSMSCode = true;
                                this.showOtp = true
                                this.PhoneInstruction = false
                                this.getCount()
                            }
                        })
                    }
                });
            });
        },
        getUserDetail(){
            this.store.callCustomerDetail({},true,this,this.type).then(() =>{
                if(this.store.customerDetail.emailVerified){
                    // this.$router.replace('/upload-image')
                    let form = {
                        'grant_type' : 'refresh_token',
                        'refresh_token' : this.store.user.refresh_token
                    };
                    this.store.refreshToken(form,false,'basic');
                }
            })
        },
        uploadImage(){
           let formData = new FormData();
           if(this.form.file.name){
                formData.append('avatar',this.form.file)
           }
           this.store.uploadUserImage(formData,true).then((response) =>{
            if(response === true){
                this.clearDoc()
                this.getUserDetail()
                if(this.store.customerDetail.emailVerified){
                    this.$router.replace('/complete-registration')
                }
            }
           })
        },
        getCountryData(code){
            if(Object.keys(this.store.countryList).length && code){
                return Object.values(this.store.countryList).filter(val => val.isoCodeA3 == code)[0]

            }
        }
    },
    mounted(){
        load(`${this.static_vars.recaptchaKey}`,{useRecaptchaNet: true}).then((recaptcha) => {
          recaptcha.execute('login').then((token) => {
              // console.log(token) // Will print the token
              this.captchaToken = token
            })
        })
        if(Object.keys(this.store.customerDetail).length){
            this.form.email = (this.store.customerDetail.email) ? this.store.customerDetail.email : ''
            this.form.fname = (this.store.customerDetail.firstName) ? this.store.customerDetail.firstName : ''
            this.form.lname = (this.store.customerDetail.lastName) ? this.store.customerDetail.lastName : ''
            this.form.phonecode = (this.store.customerDetail.countryIsoCodeA3) ? this.getCountryData(this.store.customerDetail.countryIsoCodeA3).isoCode : ''
            if(this.store.customerDetail.countryIsoCodeA3){
                this.changecountry(this.getCountryData(this.store.customerDetail.countryIsoCodeA3))
            }
            this.form.mobile = (this.store.customerDetail.phoneNumber) ? this.store.customerDetail.phoneNumber : ''
            if(this.form.mobile){
                this.form.mobile = this.form.mobile.toString();
            } 
            this.country = (this.store.customerDetail.countryIsoCodeA3) ? this.getCountryData(this.store.customerDetail.countryIsoCodeA3) : ''
            this.form.username = (this.store.customerDetail.profileName) ? this.store.customerDetail.profileName : ''
        }
        const _that = this;
        $(document).on("click", function (event) {
            if (!$(event.target).closest(".filter-dropdown").length) {
                _that.selectButton = false;
            }
        });
    },
    created(){
        this.store.callCountryList({},true).then((response) =>{
            if(Object.keys(response).length && this.store.flavorData?.userCountry?.id && !this.store.customerDetail?.countryIsoCodeA3){
                if(Object.keys(response).includes(this.store.flavorData?.userCountry?.id.toString())){
                    this.country = response[this.store.flavorData?.userCountry?.id]
                    this.changecountry(this.country)
                }else{
                    this.country = Object.values(response)[0]
                    this.changecountry(this.country)
                }
            }
            else if(Object.keys(response).length){
                this.country = Object.values(response)[0]
                this.changecountry(this.country)
            }
        })
    }
}
</script>
<style>
    /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>